import { useCallback } from 'react';
import { useUpdatePetPhoto } from '../../../lib/petMutations';
import ImageUpload, { ImageAction } from '../../ImageUpload/ImageUpload';
import styles from './PetDetails.module.scss';
import dogPlaceholderImage from '../../../../assets/images/dog-placeholder.png';
import { gqlTypes } from '../../../../types/gqlTypes';

interface PetDetailsEditableImageProps {
  pet: gqlTypes.basePet;
}

export default function PetDetailsEditableImage({ pet }: PetDetailsEditableImageProps) {
  const [updatePetPhoto] = useUpdatePetPhoto();
  const onPhotoEdited = useCallback(
    async (photo: ImageAction) => {
      try {
        await updatePetPhoto(pet.id, photo);
      } catch (err) {
        window.alert((err as any).message);
      }
    },
    [pet, updatePetPhoto],
  );

  const photo = pet.photos.first;

  return (
    <ImageUpload
      initialValue={
        photo
          ? {
              kind: 'preserve',
              photo: photo,
            }
          : undefined
      }
      onChange={onPhotoEdited}
      onError={(errorMessage) => {
        window.alert(errorMessage);
      }}
    >
      {({ src, openUploadDialog }) => (
        <img
          src={src ?? dogPlaceholderImage}
          className={styles.editableImage}
          alt={pet.name}
          onClick={openUploadDialog}
        />
      )}
    </ImageUpload>
  );
}
